import { EMPTY_FILENAME } from "../lib/utils";
import { cn } from "./helpers";

export const HeroImage: React.FC<{
  src: string;
  alt: string;
  wEffects: boolean;
}> = ({ src, alt, wEffects }) => {
  return (
    <div
      className={cn(
        "relative w-full aspect-video overflow-hidden rounded-l-[40px] rounded-tr-[40px]",
        { "bg-gray-900": wEffects, "bg-pitchlerGray": !wEffects }
      )}
    >
      {src && src !== "" && !src.includes(EMPTY_FILENAME) && (
        <img
          src={src}
          alt={alt}
          className={`absolute inset-0 object-cover w-full h-full ${
            wEffects ? "opacity-35" : "opacity-100"
          }`}
        />
      )}
      {wEffects && (
        <>
          <div
            className="hidden sm:absolute sm:-top-10 sm:right-1/2 sm:mr-10 sm:block sm:transform-gpu sm:blur-3xl pointer-events-none"
            aria-hidden="true"
          >
            <div
              className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#ff4694] to-[#776fff] opacity-20"
              style={{
                clipPath:
                  "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
              }}
            />
          </div>
          <div
            className="absolute -top-52 left-1/2 -translate-x-1/2 transform-gpu blur-3xl sm:top-[-28rem] sm:ml-16 sm:translate-x-0 sm:transform-gpu pointer-events-none"
            aria-hidden="true"
          >
            <div
              className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#ff4694] to-[#776fff] opacity-20"
              style={{
                clipPath:
                  "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
              }}
            />
          </div>
        </>
      )}
    </div>
  );
};
